/**
 * Retorna a base URL para requisições API.
 * Sempre retorna "" (string vazia) — tanto em dev (Vite proxy) quanto em
 * produção (Netlify proxy via redirects no netlify.toml) as requisições
 * vão para "/api/..." no mesmo domínio, evitando CORS.
 */
export function getApiBaseUrl(): string {
  return "";
}

export function ensureProtocol(
  url: string,
  defaultProtocol: "https:" | "http:" = "https:",
): string {
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  const proto = defaultProtocol.endsWith(":")
    ? defaultProtocol
    : `${defaultProtocol}:`;
  return `${proto}//${url}`;
}

export function normalizeUrl(base: string, endpoint: string): string {
  const b = (base || "").replace(/\/+$/g, "");
  const e = (endpoint || "").replace(/^\/+/, "");
  return `${b}/${e}`;
}

export function extractHostname(input: string): string {
  if (!input) return "";
  try {
    const u = new URL(ensureProtocol(input));
    return u.hostname;
  } catch {
    // If still fails, attempt basic extraction
    const m = input.match(/^[a-z]+:\/\/([^\/:?#]+)/i);
    if (m && m[1]) return m[1];
    return input.replace(/^\/*/, "").split("/")[0];
  }
}

export function isValidUrl(maybeUrl: string): boolean {
  if (!maybeUrl || typeof maybeUrl !== "string") return false;
  try {
    // Accept without protocol as valid host/path
    // Try with https by default
    new URL(ensureProtocol(maybeUrl));
    return true;
  } catch {
    return false;
  }
}
